/** @deprecated ZDS (@croquiscom-pvt/zds) 색상을 사용해주세요. (staticWhite) */
export const white = '#FFFFFF';
/** @deprecated ZDS (@croquiscom-pvt/zds) 색상을 사용해주세요. (staticBlack) */
export const black = '#000000';

/** @deprecated ZDS (@croquiscom-pvt/zds) 색상을 사용해주세요. */
export const Gray_Light_White = '#FFFFFF';
/** @deprecated ZDS (@croquiscom-pvt/zds) 색상을 사용해주세요. */
export const Gray_Light_Black = '#000000';

/** @deprecated ZDS (@croquiscom-pvt/zds) 색상을 사용해주세요. */
export const Gray_Dark_White = '#000000';
/** @deprecated ZDS (@croquiscom-pvt/zds) 색상을 사용해주세요. */
export const Gray_Dark_Black = '#FFFFFF';

/** @deprecated ZDS (@croquiscom-pvt/zds) 색상을 사용해주세요. */
export const Gray_Light_030 = '#F5F6F8';
/** @deprecated ZDS (@croquiscom-pvt/zds) 색상을 사용해주세요. */
export const Gray_Light_050 = '#FAFAFB';
/** @deprecated ZDS (@croquiscom-pvt/zds) 색상을 사용해주세요. */
export const Gray_Light_100 = '#F5F6F8';
/** @deprecated ZDS (@croquiscom-pvt/zds) 색상을 사용해주세요. */
export const Gray_Light_150 = '#E8E9EB';
/** @deprecated ZDS (@croquiscom-pvt/zds) 색상을 사용해주세요. */
export const Gray_Light_200 = '#D2D5D6';
/** @deprecated ZDS (@croquiscom-pvt/zds) 색상을 사용해주세요. */
export const Gray_Light_300 = '#B8BFC2';
/** @deprecated ZDS (@croquiscom-pvt/zds) 색상을 사용해주세요. */
export const Gray_Light_400 = '#A1A9AD';
/** @deprecated ZDS (@croquiscom-pvt/zds) 색상을 사용해주세요. */
export const Gray_Light_500 = '#828A8F';
/** @deprecated ZDS (@croquiscom-pvt/zds) 색상을 사용해주세요. */
export const Gray_Light_600 = '#697175';
/** @deprecated ZDS (@croquiscom-pvt/zds) 색상을 사용해주세요. */
export const Gray_Light_700 = '#4F5558';
/** @deprecated ZDS (@croquiscom-pvt/zds) 색상을 사용해주세요. */
export const Gray_Light_800 = '#34383B';
/** @deprecated ZDS (@croquiscom-pvt/zds) 색상을 사용해주세요. */
export const Gray_Light_900 = '#242729';
/** @deprecated ZDS (@croquiscom-pvt/zds) 색상을 사용해주세요. */
export const Gray_Light_950 = '#121314';

/** @deprecated ZDS (@croquiscom-pvt/zds) 색상을 사용해주세요. */
export const Gray_Dark_030 = '#1A1A1A';
/** @deprecated ZDS (@croquiscom-pvt/zds) 색상을 사용해주세요. */
export const Gray_Dark_050 = '#1F2123';
/** @deprecated ZDS (@croquiscom-pvt/zds) 색상을 사용해주세요. */
export const Gray_Dark_100 = '#222526';
/** @deprecated ZDS (@croquiscom-pvt/zds) 색상을 사용해주세요. */
export const Gray_Dark_150 = '#2F3234';
/** @deprecated ZDS (@croquiscom-pvt/zds) 색상을 사용해주세요. */
export const Gray_Dark_200 = '#414547';
/** @deprecated ZDS (@croquiscom-pvt/zds) 색상을 사용해주세요. */
export const Gray_Dark_300 = '#585C5E';
/** @deprecated ZDS (@croquiscom-pvt/zds) 색상을 사용해주세요. */
export const Gray_Dark_400 = '#717678';
/** @deprecated ZDS (@croquiscom-pvt/zds) 색상을 사용해주세요. */
export const Gray_Dark_500 = '#888E90';
/** @deprecated ZDS (@croquiscom-pvt/zds) 색상을 사용해주세요. */
export const Gray_Dark_600 = '#A3A9AC';
/** @deprecated ZDS (@croquiscom-pvt/zds) 색상을 사용해주세요. */
export const Gray_Dark_700 = '#C7CACC';
/** @deprecated ZDS (@croquiscom-pvt/zds) 색상을 사용해주세요. */
export const Gray_Dark_800 = '#D9DCDE';
/** @deprecated ZDS (@croquiscom-pvt/zds) 색상을 사용해주세요. */
export const Gray_Dark_900 = '#F5F6F8';
/** @deprecated ZDS (@croquiscom-pvt/zds) 색상을 사용해주세요. */
export const Gray_Dark_950 = '#FAFAFB';

export const Pink_Light_050 = '#FEF6FD';
/** @deprecated ZDS (@croquiscom-pvt/zds) 색상을 사용해주세요. */
export const Pink_Light_100 = '#FFEBFC';
/** @deprecated ZDS (@croquiscom-pvt/zds) 색상을 사용해주세요. */
export const Pink_Light_150 = '#FFD1F7';
/** @deprecated ZDS (@croquiscom-pvt/zds) 색상을 사용해주세요. */
export const Pink_Light_200 = '#FFB2F3';
/** @deprecated ZDS (@croquiscom-pvt/zds) 색상을 사용해주세요. */
export const Pink_Light_300 = '#FF8AEB';
/** @deprecated ZDS (@croquiscom-pvt/zds) 색상을 사용해주세요. */
export const Pink_Light_400 = '#FA6EE3';
/** @deprecated ZDS (@croquiscom-pvt/zds) 색상을 사용해주세요. */
export const Pink_Light_500 = '#E560CF';
/** @deprecated ZDS (@croquiscom-pvt/zds) 색상을 사용해주세요. */
export const Pink_Light_600 = '#BF49AB';
/** @deprecated ZDS (@croquiscom-pvt/zds) 색상을 사용해주세요. */
export const Pink_Light_700 = '#913382';
/** @deprecated ZDS (@croquiscom-pvt/zds) 색상을 사용해주세요. */
export const Pink_Light_800 = '#6D2261';
/** @deprecated ZDS (@croquiscom-pvt/zds) 색상을 사용해주세요. */
export const Pink_Light_900 = '#4F1245';

/** @deprecated ZDS (@croquiscom-pvt/zds) 색상을 사용해주세요. */
export const Pink_Dark_050 = '#4A1341';
/** @deprecated ZDS (@croquiscom-pvt/zds) 색상을 사용해주세요. */
export const Pink_Dark_100 = '#65215A';
/** @deprecated ZDS (@croquiscom-pvt/zds) 색상을 사용해주세요. */
export const Pink_Dark_150 = '#853078';
/** @deprecated ZDS (@croquiscom-pvt/zds) 색상을 사용해주세요. */
export const Pink_Dark_200 = '#AF449D';
/** @deprecated ZDS (@croquiscom-pvt/zds) 색상을 사용해주세요. */
export const Pink_Dark_300 = '#D159BD';
/** @deprecated ZDS (@croquiscom-pvt/zds) 색상을 사용해주세요. */
export const Pink_Dark_400 = '#FA6EE3';
/** @deprecated ZDS (@croquiscom-pvt/zds) 색상을 사용해주세요. */
export const Pink_Dark_500 = '#F384E1';
/** @deprecated ZDS (@croquiscom-pvt/zds) 색상을 사용해주세요. */
export const Pink_Dark_600 = '#F3ABE8';
/** @deprecated ZDS (@croquiscom-pvt/zds) 색상을 사용해주세요. */
export const Pink_Dark_700 = '#F3C8EC';
/** @deprecated ZDS (@croquiscom-pvt/zds) 색상을 사용해주세요. */
export const Pink_Dark_800 = '#F3DBEF';
/** @deprecated ZDS (@croquiscom-pvt/zds) 색상을 사용해주세요. */
export const Pink_Dark_900 = '#F2E7F0';

/** @deprecated ZDS (@croquiscom-pvt/zds) 색상을 사용해주세요. */
export const Purple_Light_050 = '#F5F5FF';
/** @deprecated ZDS (@croquiscom-pvt/zds) 색상을 사용해주세요. */
export const Purple_Light_100 = '#E8E6FF';
/** @deprecated ZDS (@croquiscom-pvt/zds) 색상을 사용해주세요. */
export const Purple_Light_150 = '#D7D4FF';
/** @deprecated ZDS (@croquiscom-pvt/zds) 색상을 사용해주세요. */
export const Purple_Light_200 = '#C1BAFF';
/** @deprecated ZDS (@croquiscom-pvt/zds) 색상을 사용해주세요. */
export const Purple_Light_300 = '#A89FFF';
/** @deprecated ZDS (@croquiscom-pvt/zds) 색상을 사용해주세요. */
export const Purple_Light_400 = '#8F82FF';
/** @deprecated ZDS (@croquiscom-pvt/zds) 색상을 사용해주세요. */
export const Purple_Light_500 = '#7463F2';
/** @deprecated ZDS (@croquiscom-pvt/zds) 색상을 사용해주세요. */
export const Purple_Light_600 = '#604EDF';
/** @deprecated ZDS (@croquiscom-pvt/zds) 색상을 사용해주세요. */
export const Purple_Light_700 = '#4B3ABF';
/** @deprecated ZDS (@croquiscom-pvt/zds) 색상을 사용해주세요. */
export const Purple_Light_800 = '#392C99';
/** @deprecated ZDS (@croquiscom-pvt/zds) 색상을 사용해주세요. */
export const Purple_Light_900 = '#29206E';

/** @deprecated ZDS (@croquiscom-pvt/zds) 색상을 사용해주세요. */
export const Purple_Dark_050 = '#271F65';
/** @deprecated ZDS (@croquiscom-pvt/zds) 색상을 사용해주세요. */
export const Purple_Dark_100 = '#352A86';
/** @deprecated ZDS (@croquiscom-pvt/zds) 색상을 사용해주세요. */
export const Purple_Dark_150 = '#4436A8';
/** @deprecated ZDS (@croquiscom-pvt/zds) 색상을 사용해주세요. */
export const Purple_Dark_200 = '#5647C2';
/** @deprecated ZDS (@croquiscom-pvt/zds) 색상을 사용해주세요. */
export const Purple_Dark_300 = '#6759D2';
/** @deprecated ZDS (@croquiscom-pvt/zds) 색상을 사용해주세요. */
export const Purple_Dark_400 = '#8F82FF';
/** @deprecated ZDS (@croquiscom-pvt/zds) 색상을 사용해주세요. */
export const Purple_Dark_500 = '#A198F3';
/** @deprecated ZDS (@croquiscom-pvt/zds) 색상을 사용해주세요. */
export const Purple_Dark_600 = '#B8B2F3';
/** @deprecated ZDS (@croquiscom-pvt/zds) 색상을 사용해주세요. */
export const Purple_Dark_700 = '#CECAF3';
/** @deprecated ZDS (@croquiscom-pvt/zds) 색상을 사용해주세요. */
export const Purple_Dark_800 = '#DEDCF3';
/** @deprecated ZDS (@croquiscom-pvt/zds) 색상을 사용해주세요. */
export const Purple_Dark_900 = '#EAEAF3';

/** @deprecated ZDS (@croquiscom-pvt/zds) 색상을 사용해주세요. */
export const Red_Light_100 = '#FFCDCC';
/** @deprecated ZDS (@croquiscom-pvt/zds) 색상을 사용해주세요. */
export const Red_Light_200 = '#FF4D4D';
/** @deprecated ZDS (@croquiscom-pvt/zds) 색상을 사용해주세요. */
export const Red_Light_300 = '#C31E18';
/** @deprecated ZDS (@croquiscom-pvt/zds) 색상을 사용해주세요. */
export const Red_Light_400 = '#9C1510';

/** @deprecated ZDS (@croquiscom-pvt/zds) 색상을 사용해주세요. */
export const Red_Dark_100 = '#EDBFBE';
/** @deprecated ZDS (@croquiscom-pvt/zds) 색상을 사용해주세요. */
export const Red_Dark_200 = '#E84747';
/** @deprecated ZDS (@croquiscom-pvt/zds) 색상을 사용해주세요. */
export const Red_Dark_300 = '#B21E18';
/** @deprecated ZDS (@croquiscom-pvt/zds) 색상을 사용해주세요. */
export const Red_Dark_400 = '#8F1511';

/** @deprecated ZDS (@croquiscom-pvt/zds) 색상을 사용해주세요. */
export const Yellow_Light_100 = '#FFDCAD';
/** @deprecated ZDS (@croquiscom-pvt/zds) 색상을 사용해주세요. */
export const Yellow_Light_200 = '#FFC274';
/** @deprecated ZDS (@croquiscom-pvt/zds) 색상을 사용해주세요. */
export const Yellow_Light_300 = '#FFA93B';
/** @deprecated ZDS (@croquiscom-pvt/zds) 색상을 사용해주세요. */
export const Yellow_Light_400 = '#F5833D';

/** @deprecated ZDS (@croquiscom-pvt/zds) 색상을 사용해주세요. */
export const Yellow_Dark_100 = '#EDCCA2';
/** @deprecated ZDS (@croquiscom-pvt/zds) 색상을 사용해주세요. */
export const Yellow_Dark_200 = '#EDB56D';
/** @deprecated ZDS (@croquiscom-pvt/zds) 색상을 사용해주세요. */
export const Yellow_Dark_300 = '#ED9D38';
/** @deprecated ZDS (@croquiscom-pvt/zds) 색상을 사용해주세요. */
export const Yellow_Dark_400 = '#E37B3A';

/** @deprecated ZDS (@croquiscom-pvt/zds) 색상을 사용해주세요. */
export const Green_Light_100 = '#80D889';
/** @deprecated ZDS (@croquiscom-pvt/zds) 색상을 사용해주세요. */
export const Green_Light_200 = '#5AC366';
/** @deprecated ZDS (@croquiscom-pvt/zds) 색상을 사용해주세요. */
export const Green_Light_300 = '#44944E';
/** @deprecated ZDS (@croquiscom-pvt/zds) 색상을 사용해주세요. */
export const Green_Light_400 = '#36753D';

/** @deprecated ZDS (@croquiscom-pvt/zds) 색상을 사용해주세요. */
export const Green_Dark_100 = '#71BB78';
/** @deprecated ZDS (@croquiscom-pvt/zds) 색상을 사용해주세요. */
export const Green_Dark_200 = '#51AA5B';
/** @deprecated ZDS (@croquiscom-pvt/zds) 색상을 사용해주세요. */
export const Green_Dark_300 = '#3E8246';
/** @deprecated ZDS (@croquiscom-pvt/zds) 색상을 사용해주세요. */
export const Green_Dark_400 = '#326838';

/** @deprecated ZDS (@croquiscom-pvt/zds) 색상을 사용해주세요. */
export const Brown_Light_100 = '#F2CEAA';
/** @deprecated ZDS (@croquiscom-pvt/zds) 색상을 사용해주세요. */
export const Brown_Light_200 = '#DEA66F';
/** @deprecated ZDS (@croquiscom-pvt/zds) 색상을 사용해주세요. */
export const Brown_Light_300 = '#CC884B';
/** @deprecated ZDS (@croquiscom-pvt/zds) 색상을 사용해주세요. */
export const Brown_Light_400 = '#8F4E18';

/** @deprecated ZDS (@croquiscom-pvt/zds) 색상을 사용해주세요. */
export const Brown_Dark_100 = '#DDBC9B';
/** @deprecated ZDS (@croquiscom-pvt/zds) 색상을 사용해주세요. */
export const Brown_Dark_200 = '#CA9867';
/** @deprecated ZDS (@croquiscom-pvt/zds) 색상을 사용해주세요. */
export const Brown_Dark_300 = '#BA7D46';
/** @deprecated ZDS (@croquiscom-pvt/zds) 색상을 사용해주세요. */
export const Brown_Dark_400 = '#7D4618';

/** @deprecated ZDS (@croquiscom-pvt/zds) 색상을 사용해주세요. */
export const Lavender_Light_100 = '#EBC7FC';
/** @deprecated ZDS (@croquiscom-pvt/zds) 색상을 사용해주세요. */
export const Lavender_Light_200 = '#E1AEF9';
/** @deprecated ZDS (@croquiscom-pvt/zds) 색상을 사용해주세요. */
export const Lavender_Light_300 = '#CD99F9';
/** @deprecated ZDS (@croquiscom-pvt/zds) 색상을 사용해주세요. */
export const Lavender_Light_400 = '#B984F9';

/** @deprecated ZDS (@croquiscom-pvt/zds) 색상을 사용해주세요. */
export const Lavender_Dark_100 = '#CCADDA';
/** @deprecated ZDS (@croquiscom-pvt/zds) 색상을 사용해주세요. */
export const Lavender_Dark_200 = '#C398D7';
/** @deprecated ZDS (@croquiscom-pvt/zds) 색상을 사용해주세요. */
export const Lavender_Dark_300 = '#B286D7';
/** @deprecated ZDS (@croquiscom-pvt/zds) 색상을 사용해주세요. */
export const Lavender_Dark_400 = '#A174D7';

/** @deprecated ZDS (@croquiscom-pvt/zds) 색상을 사용해주세요. */
export const Sky_Blue_Light_100 = '#B6D6FA';
/** @deprecated ZDS (@croquiscom-pvt/zds) 색상을 사용해주세요. */
export const Sky_Blue_Light_200 = '#98C7FA';
/** @deprecated ZDS (@croquiscom-pvt/zds) 색상을 사용해주세요. */
export const Sky_Blue_Light_300 = '#80B7F4';
/** @deprecated ZDS (@croquiscom-pvt/zds) 색상을 사용해주세요. */
export const Sky_Blue_Light_400 = '#65A7F0';

/** @deprecated ZDS (@croquiscom-pvt/zds) 색상을 사용해주세요. */
export const Sky_Blue_Dark_100 = '#A4C5EB';
/** @deprecated ZDS (@croquiscom-pvt/zds) 색상을 사용해주세요. */
export const Sky_Blue_Dark_200 = '#8DB6E4';
/** @deprecated ZDS (@croquiscom-pvt/zds) 색상을 사용해주세요. */
export const Sky_Blue_Dark_300 = '#76A7DE';
/** @deprecated ZDS (@croquiscom-pvt/zds) 색상을 사용해주세요. */
export const Sky_Blue_Dark_400 = '#5A91D0';

/** @deprecated ZDS (@croquiscom-pvt/zds) 색상을 사용해주세요. */
export const brand_color = Pink_Light_400;
